import { render, staticRenderFns } from "./EditImagemLogin.vue?vue&type=template&id=6866b2e4&scoped=true&"
import script from "./EditImagemLogin.vue?vue&type=script&lang=js&"
export * from "./EditImagemLogin.vue?vue&type=script&lang=js&"
import style0 from "./EditImagemLogin.vue?vue&type=style&index=0&id=6866b2e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6866b2e4",
  null
  
)

export default component.exports